import React, {useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {FmlxCheckBox} from 'fmlx-common-ui';
import ArrowLayer from '../../ArrowLayer/ArrowLayer';
import {generateArrowDefinition} from './serialDilutionArrowHelper';
import {getFloatingVolumeBox, validateVolumeInput} from './SerialDilutionVolumeHelper';

import withScrollInput from '../../../../lib/withScrollInput';
import FloatingNumericBox from './FloatingNumericBox';
import {SDVolumePropertyKeyEnum, SDVolumePropKeyToStepEnum, SerialDilutionStep} from '../../../../constants/dataEnum';
import {isSdStepDefined} from '../../../../stores/business/taskListSerialDilutionBusiness';
import withIntl from '../../../../lib/withIntl';

function ArrowVolumeBox({
  taskListSerialDilutionBusinessIsSdStepDefined,
  firstSerialPlateTubeIndex,
  serialPlateRatioRef,
  serialPlateRefs,
  diluentSourceRef,
  sampleSourceRef,
  aliquotRef,
  selectedCard,
  isSetSampleToAllSteps,
  onChange,
  onCheckedChange,
  intl,
  volumeCapacities,
  isHighVolumeProtocol,
}) {
  const [arrowDefinitionsWithVolumeBoxes, setArrowDefinitionsWithVolumeBoxes] = useState({});
  const [floatingVolumeBoxesComponent, setFloatingVolumeBoxesComponent] = useState();
  const [arrowComponent, setArrowComponent] = useState();
  const [checkAllSamplePosition, setCheckAllSamplePosition] = useState({x: 0, y: 0});
  const {ID} = selectedCard || {};

  const ScrollFloatingNumBox = withScrollInput(FloatingNumericBox);

  /*
  const isTextBoxDisabled = (key) => {
    if (!selectedCard) {
      return false;
    }

    switch (key) {
      case SDVolumePropertyKeyEnum.DILUENT_VOLUME: {
        return !(taskListSerialDilutionBusinessIsSdStepDefined(ID, SerialDilutionStep.SET_DILUENT_SOURCE));
      }
      case SDVolumePropertyKeyEnum.STEP_DILUENT_VOLUME:
        return !taskListSerialDilutionBusinessIsSdStepDefined(SerialDilutionStep.SET_DILUENT_SOURCE);
      case SDVolumePropertyKeyEnum.STEP_SAMPLE_VOLUME:
        return textBoxStep >= step;
      default:
        return false;
    }
  };
  */

  const mapArrowDefWithVolumeBox = (arrowDefs, volumeBoxes) => {
    const arrowDefsWithVolumeBox = {};

    arrowDefs.forEach((el) => {
      const {key, field} = el;
      const serialStep = SDVolumePropKeyToStepEnum[key];
      let isActive = taskListSerialDilutionBusinessIsSdStepDefined(ID, serialStep);

      if (
        key === SDVolumePropertyKeyEnum.DILUENT_VOLUME ||
        key === SDVolumePropertyKeyEnum.STEP_DILUENT_VOLUME ||
        key === SDVolumePropertyKeyEnum.STEP_SAMPLE_VOLUME
      )
        isActive = true;

      const volumeBoxProps = volumeBoxes[key];

      arrowDefsWithVolumeBox[key] = {
        arrowDefs: el,
        volumeBoxProps,
        isActive,
        key,
        field,
      };
    });

    return arrowDefsWithVolumeBox;
  };

  const onChangeHandler = useCallback(
    (e, field, isStepProperty, stepNumber) => {
      onChange(field, Number(e), isStepProperty ? stepNumber : null);
    },
    [onChange],
  );

  const showArrowsAndFloatingVolumeBoxes = useCallback(
    (arrowAndVolumeBoxes, forceReRenderArrow) => {
      const arrowDefsWithVolumeArr = Object.values(arrowAndVolumeBoxes);
      const reRenderArrowComponent = forceReRenderArrow || Object.values(arrowDefinitionsWithVolumeBoxes).length === 0;

      if (arrowDefsWithVolumeArr.length === 0) return;

      const arrowComponents = [];
      const volumeBoxComponents = [];

      const {sdProperty: sdPropertyRedux} = selectedCard || {};
      const {stepProperties, aliquotVolume} = sdPropertyRedux || {};
      const isAliquotDefined = taskListSerialDilutionBusinessIsSdStepDefined(
        ID,
        SDVolumePropKeyToStepEnum.aliquotVolume,
      );

      arrowDefsWithVolumeArr.forEach((el) => {
        const {arrowDefs, volumeBoxProps, isActive, key, field} = el;
        arrowComponents.push(
          <ArrowLayer arrowDefinitions={arrowDefs.props} color={isActive ? 'black' : '#CACACA'} id={key} />,
        );

        volumeBoxProps.forEach((volProp, index) => {
          const isStepProperty = key.startsWith('step');
          if (key === SDVolumePropertyKeyEnum.ALIQUOT_VOLUME) {
            const {position} = volProp;
            setCheckAllSamplePosition({x: position.x, y: position.y});
          }

          // step sample volume are shown on the left side of the tube/step to visualized sample volume entering the tube
          // so on step sample volume field, the textbox have stepNumber + 1 properties
          const stepNumber =
            field === SDVolumePropertyKeyEnum.STEP_SAMPLE_VOLUME
              ? index + firstSerialPlateTubeIndex + 2
              : index + firstSerialPlateTubeIndex + 1;
          // step number starts from 1, thus the index are stepNumber - 1
          const currentStepProperty = stepProperties ? stepProperties[stepNumber - 1] : {};
          const sdPropertyValue =
            sdPropertyRedux && typeof sdPropertyRedux[field] !== 'undefined' ? sdPropertyRedux[field] : 0;
          const stepPropertyValue =
            currentStepProperty && typeof currentStepProperty[field] !== 'undefined' ? currentStepProperty[field] : 0;
          let maxValue = volProp?.max;
          let warningTooltip = {isShow: false, label: ''};

          if (stepProperties) {
            if (key === SDVolumePropertyKeyEnum.STEP_SAMPLE_VOLUME) {
              let stepSampleVol = stepProperties[index + firstSerialPlateTubeIndex]?.stepSampleVolume;

              if (index === 0) stepSampleVol = isAliquotDefined ? aliquotVolume || 0 : 0;

              // eslint-disable-next-line no-unsafe-optional-chaining
              maxValue = stepSampleVol + stepProperties[index + firstSerialPlateTubeIndex]?.stepDiluentVolume;
            }

            if (
              key === SDVolumePropertyKeyEnum.ALIQUOT_VOLUME &&
              selectedCard?.sdProperty?.aliquotVolume >= selectedCard?.sdProperty?.sampleVolume &&
              taskListSerialDilutionBusinessIsSdStepDefined(ID, SerialDilutionStep.SET_SAMPLE_SOURCE) &&
              taskListSerialDilutionBusinessIsSdStepDefined(ID, SerialDilutionStep.SET_SAMPLE_TARGET)
            ) {
              warningTooltip = {
                isShow: true,
                label: intl.formatMessage({id: 'protocolEditor.serialDilution.volumeTextBox.tooltip.deadVolume.label'}),
              };
            } else if (isHighVolumeProtocol && volumeCapacities.min && volumeCapacities.recommended) {
              const isStepValueBelowRecommended = validateVolumeInput(
                stepPropertyValue,
                volumeCapacities.recommended.value,
              );
              const isAliquotVolumeBelowRecommended =
                key === SDVolumePropertyKeyEnum.ALIQUOT_VOLUME &&
                validateVolumeInput(selectedCard?.sdProperty?.aliquotVolume, volumeCapacities.recommended.value);
              const isSampleVolumeBelowRecommended =
                key === SDVolumePropertyKeyEnum.SAMPLE_ALIQUOT_VOLUME &&
                validateVolumeInput(selectedCard?.sdProperty?.sampleVolume, volumeCapacities.recommended.value);
              const isDiluentVolumeBelowRecommended =
                key === SDVolumePropertyKeyEnum.DILUENT_VOLUME &&
                validateVolumeInput(selectedCard?.sdProperty?.diluentVolume, volumeCapacities.recommended.value);

              if (
                isStepValueBelowRecommended ||
                isSampleVolumeBelowRecommended ||
                isAliquotVolumeBelowRecommended ||
                isDiluentVolumeBelowRecommended
              ) {
                warningTooltip = {
                  variant: 'warning',
                  isShow: true,
                  label: intl.formatMessage(
                    {id: `protocolEditor.serialDilution.highCV.info`},
                    {recommendedCapacity: volumeCapacities.recommended?.value},
                  ),
                };
              }
            }
          }

          volumeBoxComponents.push(
            <ScrollFloatingNumBox
              key={`${key}-${stepNumber}-${stepPropertyValue}`}
              id={key}
              value={isStepProperty ? stepPropertyValue : sdPropertyValue}
              hidden={!isActive}
              onChange={(e) => onChangeHandler(e, field, isStepProperty, stepNumber)}
              onBlur={(e) => onChangeHandler(e, field, isStepProperty, stepNumber)}
              maxValue={maxValue}
              warningTooltip={warningTooltip}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...volProp}
            />,
          );
        });
      });

      setFloatingVolumeBoxesComponent(volumeBoxComponents);
      if (reRenderArrowComponent) setArrowComponent(arrowComponents);
    },
    [
      ID,
      arrowDefinitionsWithVolumeBoxes,
      firstSerialPlateTubeIndex,
      intl,
      isHighVolumeProtocol,
      volumeCapacities,
      onChangeHandler,
      selectedCard,
      taskListSerialDilutionBusinessIsSdStepDefined,
    ],
  );

  const getArrowDefinitionsWithVolumeBox = useCallback(
    (forceReRenderArrow) => {
      // get arrow definitions
      const result = generateArrowDefinition(
        serialPlateRatioRef,
        serialPlateRefs,
        diluentSourceRef,
        sampleSourceRef,
        aliquotRef,
      );

      // get floating volume boxes positions and props
      const floatingVolumeBoxes = getFloatingVolumeBox(result);

      // map them based on key properties and save to state
      const mappedArrowWithFloatingBox = mapArrowDefWithVolumeBox(result, floatingVolumeBoxes);
      setArrowDefinitionsWithVolumeBoxes(mappedArrowWithFloatingBox);

      // turns properties into components
      showArrowsAndFloatingVolumeBoxes(mappedArrowWithFloatingBox, forceReRenderArrow);

      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedCard, isSetSampleToAllSteps],
  );

  useEffect(() => {
    getArrowDefinitionsWithVolumeBox(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCard, isSetSampleToAllSteps]);

  useEffect(() => {
    showArrowsAndFloatingVolumeBoxes(arrowDefinitionsWithVolumeBoxes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstSerialPlateTubeIndex]);

  useEffect(() => {
    window.addEventListener('resize', getArrowDefinitionsWithVolumeBox);
    return () => {
      window.removeEventListener('resize', getArrowDefinitionsWithVolumeBox);
    };
  }, [getArrowDefinitionsWithVolumeBox]);

  return (
    <span className="serial-dilution__arrow-volume-box">
      <div className="serial-dilution__arrow-volume-box__arrow">{arrowComponent}</div>
      <div className="serial-dilution__arrow-volume-box__volume-box">{floatingVolumeBoxesComponent}</div>
      <div className="serial-dilution__arrow-volume-box__volume-box">
        <div
          className="floating-numeric-box"
          style={{
            top: checkAllSamplePosition.y + 35,
            left: checkAllSamplePosition.x - 15,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <FmlxCheckBox
            checked={isSetSampleToAllSteps}
            onChange={onCheckedChange}
            size={FmlxCheckBox.Size.SMALL}
            label={intl.formatMessage({id: 'protocolEditor.serialDilution.checkBox.allSample.label'})}
          />
        </div>
      </div>
    </span>
  );
}

ArrowVolumeBox.propTypes = {
  taskListSerialDilutionBusinessIsSdStepDefined: PropTypes.func.isRequired,
  firstSerialPlateTubeIndex: PropTypes.number.isRequired,
  serialPlateRatioRef: PropTypes.object.isRequired,
  serialPlateRefs: PropTypes.object.isRequired,
  diluentSourceRef: PropTypes.object.isRequired,
  sampleSourceRef: PropTypes.object.isRequired,
  aliquotRef: PropTypes.object.isRequired,
  selectedCard: PropTypes.object.isRequired,
  isSetSampleToAllSteps: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onCheckedChange: PropTypes.func,
  intl: PropTypes.object.isRequired,
  volumeCapacities: PropTypes.object,
  isHighVolumeProtocol: PropTypes.bool,
};

ArrowVolumeBox.defaultProps = {
  isSetSampleToAllSteps: false,
  onCheckedChange: () => {},
  volumeCapacities: {},
  isHighVolumeProtocol: false,
};

const mapStateToProps = (state) => ({
  temporaryStateIsDilutionSetToAllSample: state.temporaryState.isDilutionSetToAllSample,
});

const mapDispatchToProps = (dispatch) => ({
  taskListSerialDilutionBusinessIsSdStepDefined: bindActionCreators(isSdStepDefined, dispatch),
});

export default withIntl(connect(mapStateToProps, mapDispatchToProps)(ArrowVolumeBox));
